// TODO: Remove unused code

$(document).ready(function () {
  $('.hamburger-icon').on('click', function () {
    $(this).toggleClass('active-hamburger')
    $('.nav-section').toggleClass('show-nav')
    $('.site-nav__dropdown').removeClass('active-sub')
    $('.black-over').fadeToggle('fast')
    //$(".close_1").click();
    $("#added-box-wrapper").removeClass('showcart')
    // $('.site-header__cart').removeClass("active-bag");
    $('.search-box').removeClass('active-box')
    $('.login-account-box').removeClass('active-box')
    updateNavSizePosition()
  })

  $('.black-over').on('click', function () {
    $('.hamburger-icon').removeClass('active-hamburger')
    $('.nav-section').removeClass('show-nav')
    $('.site-nav__dropdown').removeClass('active-sub')
    $('.black-over').fadeOut('fast')
    $('.show-box').removeClass('active-box')
    $("#added-box-wrapper").removeClass('showcart')
    // $('.site-header__cart').removeClass("active-bag");
  })

  $('.login-icon').on('click', function () {
    $("#added-box-wrapper").removeClass('showcart')
  })

  $('.search-icon').on('click', function () {
    $("#added-box-wrapper").removeClass('showcart')
  })

  $('.announcement-bar .close_bar').on('click', function () {
    $(".announcement-bar").fadeOut()
  })

  $('#cookies .close_bar, #cookies .white-btn').on('click', function () {
    $("#cookies").fadeOut()
  })

  $('.site-nav--has-dropdown button').on('click', function () {
    $('.site-nav--has-dropdown').find('.site-nav__dropdown').removeClass('active-sub')
    $(this).closest('.site-nav--has-dropdown').find('.site-nav__dropdown').stop().addClass('active-sub')
  })

  $('.back_button').on('click', function () {
    $('.site-nav--has-dropdown').find('.site-nav__dropdown').removeClass('active-sub')
  })

  $('.footer_instagram_link a, .footer_facebook_link a, .footer_twitter_link a').attr("target", "_blank")

  $('.close-box, .acc_back_button a').on('click', function () {
    $('.show-box').removeClass('active-box')
    $('.black-over').fadeOut('fast')
  })

  $('.search-icon a').on('click', function () {
    $('.search-box').toggleClass('active-box')
    $('.black-over').fadeIn('fast')
  })

  $('.login-icon a, .account-icon .x_icon_hover').on('click', function () {
    $('.login-account-box').toggleClass('active-box')
    $('.black-over').fadeIn('fast')
  })

  $(".site-header__cart, #added-box-wrapper .cart-icon .x_icon_hover").click(function () {
    // $("#added-box-wrapper").toggleClass("showcart");
    // $(".site-header__cart").toggleClass("active-bag");
    $("body").toggleClass('body_noscroll')
    $('.mo_navigation').slideUp()
    $('.black-over').fadeIn('fast')
    $('.hamburger-icon').removeClass('active-hamburger')
    $('.nav-section').removeClass('show-nav')
    $('.site-nav__dropdown').removeClass('active-sub')
  })

  $(".select_size").click(function () {
    // $(".size-colorbox .show_swatches").slideUp();
    $(this).next(".show_swatches").slideToggle()
  })

  $('.qtybox .btnqty').on('click', function () {
    var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val())
    if ($(this).hasClass('qtyplus')) {
      qty++
    } else {
      if (qty > 1) {
        qty--
      }
    }
    qty = (isNaN(qty)) ? 1 : qty
    $(this).parent('.qtybox').find('.quantity-input').val(qty)
  })


  $(".arrow_down").click(function () {
    $('html, body').animate({
      scrollTop: $("#MainContent .shopify-section:nth-child(2)").offset().top
    }, 700)
  })


})
//end here




// body load
$(window).on('load', function () {
  $(".home_slideshow").addClass('height_auto')

  $(".announcement_box").addClass('heightauto')

  $(".logo-bar").css('opacity', '1')
  $(".slideshow_loading").css('opacity', '1')

  setTimeout(function () {
    $(".template-collection a.text-m").removeAttr('href')
  }, 1000)

  /*
$("#slider .slides li").each(function(){
  var slideWidth = $(this).find('img').width();
  $(this).css('width', (slideWidth+1));
});
*/

  //   setTimeout(function(){
  //     	$("button.write-review-button").text("Be the first to write a review");
  //     	$('h2.y-label.yotpo-header-title').text("Write A Review");
  //     	//alert('1');
  //     	$(".template-index .yotpo-bottomline a.text-m").removeAttr('href');

  //     	$('.bottom-line-items-container-desktop .bottom-line-items-wrapper .avg-score, .bottom-line-items-container-mobile .avg-score').html('Reviews');

  //   }, 1000);

})







